<template>
    <NuxtLink class="bg-none leading-none" title="Twitter" to="https://x.com/_rainbowatcher" external target="_blank">
        <i class="i-ph-twitter-logo" />
    </NuxtLink>
    <NuxtLink class="bg-none leading-none" title="GitHub" to="https://github.com/rainbowatcher" external target="_blank">
        <i class="i-ph-github-logo" />
    </NuxtLink>
</template>
